<h2 mat-dialog-title>Add Personal Todo</h2>

<mat-dialog-content [formGroup]="form" class="dialog-body">
  <section class="form-card">
    <div class="form-grid">
      <mat-form-field appearance="outline">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title">
        <mat-error *ngIf="form.get('title')?.hasError('required')">Title is required.</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Priority</mat-label>
        <mat-select formControlName="priority">
          <mat-option value="Low">Low</mat-option>
          <mat-option value="Medium">Medium</mat-option>
          <mat-option value="High">High</mat-option>
          <mat-option value="Urgent">Urgent</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status">
          <mat-option value="Pending">Pending</mat-option>
          <mat-option value="In Progress">In Progress</mat-option>
          <mat-option value="Blocked">Blocked</mat-option>
          <mat-option value="Done">Done</mat-option>
          <mat-option value="Completed">Completed</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Due Date</mat-label>
        <input matInput type="date" formControlName="dueDate">
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Description</mat-label>
      <textarea matInput rows="5" formControlName="description"></textarea>
    </mat-form-field>
  </section>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="dialogRef.close()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="save()">Add Todo</button>
</mat-dialog-actions>
